




































import { NeedModel, PatchBatchDocument } from '@/libs/Api';
import { needsStore } from '@/libs/needs/+state/store';
import { CrudAction, CrudReponse, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import NeedDialog from '@/libs/settings/components/NeedDialog.vue';

import draggable from 'vuedraggable'

@Component({
    components: {
        NeedDialog,
        draggable
    }
})
export default class Needs extends Page {

    filterActive = true;
    subscribtion: any = null;
    items: NeedModel[] = [];
    @Prop() tenantId!: string;

    get loading(): boolean {
        return needsStore.useGetter(CrudGetter.Pending);
    }

    @Ref() dialog!: NeedDialog;
    
    @Watch("filterActive")
    filtersChanged() {
        this.loadItems();
    }
    
    get newPosition(): number {
        return this.items.length > 0 ? this.items.max(x => x.position!) + 1 : 1;
    }

    mounted () {
        this.loadItems();
        const self = this;
        this.subscribtion = this.$store.subscribe((mutation, _state) => {
            if (mutation.type === needsStore.getActionName(CrudResponseAction.CreateSuccess)) {
                if (!self.items.any(x => x.id == mutation.payload?.item?.id)) {
                    self.items.push(mutation.payload!.item!);
                }
            }
            else if (mutation.type === needsStore.getActionName(CrudResponseAction.PartialUpdateSuccess)) {
                self.items.forEach((x) => {
                    if (x.id == mutation.payload?.item?.id) {
                        self.items.splice(self.items.indexOf(x), 1, mutation.payload!.item);
                    }
                });
            }
            else if (mutation.type === needsStore.getActionName(CrudResponseAction.UpdateSuccess)) {
                self.items.forEach((x) => {
                    if (x.id == mutation.payload?.item?.id) {
                        self.items.splice(self.items.indexOf(x), 1, mutation.payload!.item);
                    }
                });
            }
            else if (mutation.type === needsStore.getActionName(CrudResponseAction.DeleteSuccess)) {
                self.items.forEach((x) => {
                    if (mutation.payload?.data.any((t: NeedModel) => t.id == x.id)) {
                        self.items.splice(self.items.indexOf(x), 1);
                    }
                });
            }
        })
    }

    destroyed () {
        if (typeof this.subscribtion == "function")
            this.subscribtion();
    }

    loadItems () {
        let filters = [
            { field: "isActive", op: "eq", comparand: this.filterActive }
        ];
        needsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<NeedModel>([
            { field: "position", index: 1, order: "asc" }
        ], filters));
        this.subscribe(needsStore, CrudReponse.GetAll).then((e: NeedModel[]) => {
            this.items = e;
        });
    }

    createItemClick () {
        this.dialog.open();
    }

    openItemClick (v: NeedModel) {
        this.dialog.open(v.id);
    }

    dragEnd (e: any) {
        const documentList: PatchBatchDocument[] = this.items.map((e) => {
            const doc: PatchBatchDocument = {
                id: e.id,
                operations: [
                    { path: "/position", op: "replace", value: this.items.indexOf(e) + 1 }
                ]
            };
            return doc;
        });
        needsStore.dispatch(CrudAction.BatchPartialUpdate, {
            diffs: documentList
        });
    }

}
